/* TrustSignalCard.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["cardStyles", "isWebCoherenceEnabled", "statsColor"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { BodyLarge, H2 } from '@atlassian/mpac-primitives';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _23 = "._t1t69y44 dt{font-weight:800}";
const _22 = "._t1t61fw0 dt{font-weight:700}";
const _21 = "._2rko12b0{border-radius:var(--ds-radius-small,4px)}";
const _20 = "._2rkov47k{border-radius:var(--ds-space-250,20px)}";
const _19 = "@media (min-width:110.5rem){._17gs1gwv{max-width:360px}}";
const _18 = "._yd8b1kw7 dt{letter-spacing:inherit}";
const _17 = "._13esangw dt{text-transform:uppercase}";
const _16 = "._126d1aoy dt{color:var(--_zhc8i5)}";
const _15 = "._142snl7k dd{letter-spacing:.3px}";
const _14 = "._e0w3v0yc dd{margin:var(--ds-space-100,8px) 0 0 0}";
const _13 = "._1rusdjbo:before{background-color:var(--_1snsa0d)}";
const _12 = "._kfgtckbl:before{height:3pc}";
const _11 = "._1mp41y44:before{width:4px}";
const _10 = "._qnecidpf:before{left:0}";
const _9 = "._1cs8stnw:before{position:absolute}";
const _8 = "._1kt9b3bt:before{content:\"\"}";
const _7 = "._rfx3bx74:before{border-radius:0 var(--ds-radius-small,4px) var(--ds-radius-small,4px) 0}";
const _6 = "._19pkidpf{margin-top:0}";
const _5 = "._1ul9ncxg{min-width:264px}";
const _4 = "._bfhk1y1v{background-color:var(--_ldqei4)}";
const _3 = "._kqswh2mm{position:relative}";
const _2 = "._1yt4xy5q{padding:var(--ds-space-400,2pc)}";
const _ = "._19it10s1{border:var(--_1y56ji6)}";
const Card = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      cardStyles,
      isWebCoherenceEnabled,
      statsColor
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_ldqei4": ix(__cmplp.cardStyles.backgroundColor),
        "--_1y56ji6": ix(__cmplp.cardStyles.border),
        "--_1snsa0d": ix(__cmplp.cardStyles.slabColor),
        "--_zhc8i5": ix(__cmplp.statsColor)
      }),
      ref: __cmplr,
      className: ax(["_19it10s1 _1yt4xy5q _kqswh2mm _bfhk1y1v _1ul9ncxg _19pkidpf _rfx3bx74 _1kt9b3bt _1cs8stnw _qnecidpf _1mp41y44 _kfgtckbl _1rusdjbo _e0w3v0yc _142snl7k _126d1aoy _13esangw _yd8b1kw7 _17gs1gwv", __cmplp.isWebCoherenceEnabled ? "_2rkov47k" : "_2rko12b0", __cmplp.isWebCoherenceEnabled ? "_t1t61fw0" : "_t1t69y44", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Card.displayName = 'Card';
}
export const TrustSignalCard = _ref2 => {
  let {
    stats,
    label,
    cardStyles,
    statsStyles,
    isWebCoherenceEnabled
  } = _ref2;
  return /*#__PURE__*/_jsxs(Card, {
    isWebCoherenceEnabled: isWebCoherenceEnabled,
    cardStyles: cardStyles,
    statsColor: statsStyles.color,
    children: [/*#__PURE__*/_jsx(H2, {
      as: "dt",
      children: stats
    }), /*#__PURE__*/_jsx(BodyLarge, {
      as: "dd",
      children: label
    })]
  });
};